import { Box, Table, Typography } from "@mui/material";
import React from "react";
import TicketTable from "./TicketTable";
import SideNavbar from "../../components/sideNavbar";
import Header from "../../components/header";

const AgentTickets = () => {
  return (
    <>
      <Box
        sx={{
          ml: { xs: "0px", md: "280px" },
        }}
      >
        <SideNavbar />

        <Box
          sx={{
            p: 0,
          }}
        >
          <TicketTable />
        </Box>
      </Box>
    </>
  );
};

export default AgentTickets;
